import { render } from "./DeleteAccountPage.vue?vue&type=template&id=761ecdf3"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=js"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__